import * as React from "react";
import {
  Button,
  Card,
  Chip,
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Menu,
  ListItemText,
  Stack,
  FormLabel,
  CircularProgress,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Grid from "@mui/material/Grid";
import { useGetSyncedProductsMutation } from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import AppGrid from "../../app/AppGrid";
import PageLoader from "../../app/PageLoader";
import { ShippingContextType, ShipProfileContext } from "./ShippingProfile";
import { AppFilter } from "../../../models/app/AppModels";
import ServerAppGrid from "../../app/ServerAppGrid";

interface ShippingProductsProps {
  handleNext: any;
  handleBack: any;
}
const ShippingProducts: React.FunctionComponent<ShippingProductsProps> = ({
  handleBack,
  handleNext,
}) => {
  const { profile, setProfile } = React.useContext(
    ShipProfileContext
  ) as ShippingContextType;
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);

  const [syncProduct, syncProductResult] = useGetSyncedProductsMutation();

  React.useEffect(() => {
    fetchData();
  }, [paging]);

  React.useEffect(() => {
    console.log("Context Data", profile);
  }, [selectedRows]);

  React.useEffect(() => {
    console.log("producys", products);
  }, [products]);
  const fetchData = () => {
    syncProduct({
      setupId: dmsSetup?.id ?? "",
      paging: paging,
      productType: 0,
    });
  };
  React.useEffect(() => {
    if (syncProductResult.data) {
      setProducts(syncProductResult.data.entityList);
      setProductsCount(syncProductResult.data.totalRecords);
    }
  }, [syncProductResult]);

  const columns: GridColDef[] = [
    {
      field: "modelNumber",
      headerName: "Model Number",
      width: 210,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.productId ? (
          <>
            <Box
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: "white",
              }}
            >
              <img
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                alt=""
                src={getIconImageUrl(
                  params.row.shopifyProduct &&
                    params.row.shopifyProduct.images.length !== 0
                    ? params.row.shopifyProduct.images[0].src
                    : ""
                )}
              ></img>{" "}
            </Box>
            <Typography sx={{ cursor: "pointer" }} color="primary" pl={3}>
              {params.row.modelNumber}
            </Typography>
          </>
        ) : (
          <Typography>{params.row.modelNumber}</Typography>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      width: 150,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.title,
    },
    {
      field: "model",
      headerName: "Model",
      width: 100,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.model,
    },
    {
      field: "price",
      headerName: "DMS Price ($)",
      headerAlign: "right",
      width: 120,
      filterable: false,
      type: "number",
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "suggestedRetailPrice",
      headerName: "DMS Retail Price ($)",
      headerAlign: "right",
      width: 150,
      filterable: false,
      type: "number",
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.suggestedRetailPrice.toFixed(2),
    },
    {
      field: "storeprice",
      headerName: "Online Price ($)",
      headerAlign: "right",
      width: 120,
      filterable: false,
      type: "number",
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? params.row.shopifyProduct.variants[0].price.toFixed(2)
          : "0.00",
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
    },

    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(
          params.row.shopifyProduct
            ? params.row.shopifyProduct.status
            : "Active"
        );
      },
    },
    {
      field: "type",
      headerName: "Type",
      width: 100,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.productId ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : (
          <Chip label="DMS" color="warning" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "Action",
      type: "actions",
      width: 80,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Chip
            label="View"
            color="info"
            onClick={() => {
              window.open(
                `${dmsSetup?.shopifyUrl}/products/${params.row?.shopifyProductLink}`,
                "_blank"
              );
            }}
          />
        );
      },
    },
  ];

  const getStatusChip = (status: string) => {
    if (status === "active")
      return <Chip label="Active" color="success" size="small" />;
    else return <Chip label="Draft" color="error" size="small" />;
  };

  //   const getSelectedRowData = () => {
  //     return selectedRows.map((rowId: any) => {
  //       let item = products.find((n) => n.id === rowId);
  //       if (item) {
  //         return {
  //           shopifyProductId: item.shopifyProductId,
  //           productAggId: rowId,
  //         };
  //       }
  //     });
  //   };

  const getIconImageUrl = (imgUrl: string) => {
    var splitImageUrl = imgUrl.split(".");
    return (
      splitImageUrl[0] +
      "." +
      splitImageUrl[1] +
      "." +
      splitImageUrl[2] +
      "_350x350." +
      splitImageUrl[3]
    );
  };
  return (
    <>
      <Container maxWidth="lg" sx={{ height: "70vh" }}>
        <Card>
          <ServerAppGrid
            data={syncProductResult.isLoading ? [] : products}
            columns={columns}
            isLoading={syncProductResult.isLoading}
            selectedRows={selectedRows}
            getRowId={(row) => row.shopifyProduct.variants[0]?.id}
            onSelect={(newSelection: any) => {
              setSelectedRows(newSelection);
              setProfile({ ...profile, variantsToAssociate: newSelection });
            }}
            paging={paging}
            setPaging={setPaging}
            totalRecords={productsCount}
            keepNonExistentRowsSelected={false}
          ></ServerAppGrid>
        </Card>
      </Container>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button onClick={handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
        <Button disabled={selectedRows.length === 0} onClick={handleNext}>
          Next
        </Button>
      </Box>
    </>
  );
};

export default ShippingProducts;
